export default __webpack_public_path__ + "static/TSD_Quote_2-be5b850c455da6823cf436c85b646481.png";